import { Chip, ChipProps } from '@mui/material';
import { AvatarCurrency } from '../Avatar/AvatarCurrency';
import { UiAccount } from '../../types';
import { useTranslation } from 'react-i18next';

export type AccountChipProps = ChipProps<'div', { account: UiAccount }>;

export function AccountChip({ account, ...props }: AccountChipProps) {
  const { t } = useTranslation();

  return (
    <Chip
      {...props}
      avatar={<AvatarCurrency currency={account.balance.currency} />}
      label={account.name ?? t('Account {{currency}}', { currency: account.balance.currency })}
    />
  );
}
